import { Documents } from "./documents/Documents";
import { Entities } from "@timesheets/webapp-support";
import { IState } from "../../IState";
import { Id } from "@gemma/typescript-types";
import { Store } from "vuex";
import { WireEntities } from "@timesheets/common";

export class User implements Entities.IUser {
  private readonly _store: Store<IState>;

  readonly documents: Entities.Documents.IDocuments;

  get roles(): Readonly<WireEntities.Roles.IRecruitmentAgencyRole<unknown>>[] {
    return this._store.state.user.roles;
  }

  constructor(store: Store<IState>) {
    this._store = store;
    this.documents = new Documents(store);
  }

  hasRole(recruitmentAgencyAdministrationRole: Id<string> | WireEntities.Roles.IRecruitmentAgencyAdministrationRole): boolean {
    const recruitmentAgencyAdministrationRoleId = typeof recruitmentAgencyAdministrationRole === "string" ? recruitmentAgencyAdministrationRole : recruitmentAgencyAdministrationRole.id;
    const hasRole = this._store.state.user.roles.find(role => role.id === recruitmentAgencyAdministrationRoleId);

    return !!hasRole;
  }

  setHourFormat(hourFormat: WireEntities.RecruitmentAgency.IHourFormat, recruitmentAgency: WireEntities.Roles.IRecruitmentAgencyRole<unknown> | Id<string>): void {
    this._store.dispatch("user/setHourFormat", { hourFormat, recruitmentAgency });
  }
}
